export default {
  "en-gb": {
    metaData: {
      title: "Gas engine product selector | Mobil™",
      desc: "Find the right oil for your gas engine."
    },
    header: {
      businessLines: {
        text: `Business line`,
        link: "https://corporate.exxonmobil.com/?query=https%3a%2f%2fdnet.mobil.com%2fen%2f#business-lines"
      },
      globalBrands: {
        text: `Global brands`,
        link: "https://corporate.exxonmobil.com/?query=https%3a%2f%2fdnet.mobil.com%2fen%2f#global-brands"
      }
    },
    languages: {
      active: {
        text: 'UK - English',
        link: "#"
      },
      english: {
        text: 'UK - English',
        link: "/en/"
      },
      german: {
        text: 'Deutschland - Deutsch',
        link: "/de/"
      },
      turkish: {
        text: 'Türkiye - Türk',
        link: "/tr/"
      },
      italian: {
        text: 'Italia - Italiano',
        link: "/it/"
      },
      french: {
        text: 'France - Francais',
        link: "/fr/"
      },
      polish: {
        text: 'Polska - Polski',
        link: "/pl/"
      }
    },
    email: {
      title: "Your Mobil™ product recommendation is attached",
      salutation: "Hello",
      placeholder: "Email*",
      sending: "Sending...",
      message:
        "Thanks for visiting the <a href='https://geoselector.eame.mobil.com/en/'>Mobil gas engine oils webpage</a>. Please find attached your requested Mobil™ product recommendation.​\n\nIn case you have technical questions or want to know where you can buy the recommended gas engine oils, <a href='https://www.global.mobil.com/en/contact-us​'>please contact us</a>.\n\nKind regards,\n\nThe Mobil team",
      pdfFileName: "Product-recommendation.pdf",
      sendButton: "Send",
      successfulEmailMessage: "Email has been sent. If you can not locate it in your inbox please check your spam or junk mail folder.",
      privacyPolicy: "Privacy policy",
      termsAndConditions: "Terms and conditions",
    },
    breadcrumbs: {
      yourSelection: "Your selection: "
    },
    cookies: {
      consentCopy:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      acceptButton: "Accept cookies",
      rejectButton: "No thanks",
    },
    common: {
      compareRecos: "Compare recommended products",
      moreRecos: "More recommendations",
      productSelector: "Mobil product selector for your gas engine",
      endOfpageNotes: `Can’t find your gas engine model or specification? [Tell us](https://www.global.mobil.com/en/contact-us). 

At the same time, we recommend that you refer to the product recommendations according to the specifications provided by the manufacturer to ensure that the products are suitable for your gas engine.

As the company continues to research and improve products, the product information posted may be updated at any time without notice. Standard performance may vary slightly. 

Not all products are available to all markets and may be only applicable to selected countries. [Contact our technical help desk](https://www.global.mobil.com/en/contact-us) for tailored solutions to your gas engine requirements and location. 

[Disclaimer](#/disclaimer)`,
    },
    copyright: {
      text: "© Copyright 2021 Exxon Mobil Corporation. All rights reserved."
    },
    button: {
      moreHelp: `**Need more help locating your gas engine or recommendation?**  
Contact our technical help desk for more support.`,
      moreHelpUrl: `https://www.global.mobil.com/en/contact-us`,
      visitHub: `**Visit the Mobil gas engine page for the latest industry insights, trends, products and service information.**`,
      visitHubUrl: `https://www.mobil.eu/en-gb/lubricants/applications/gas-engines`,
      MSLA: `**Discover the benefits of Mobil services for gas engines.**`,
      MSLAUrl: `https://www.mobil.eu/en-gb/lubricants/applications/gas-engines`,
      moreTechInfo: `**Do you need more technical or commercial information, contact our experienced team today.**`,
      moreTechInfoUrl: `https://www.global.mobil.com/en/contact-us`,
      viewProductDetails: "View full product details",
      downloadPerformanceProfile: "Download performance profile PDF",
      downloadSuccessStories: "Download success stories PDF",
      alt_downloadPerformanceProfile: "Performance profile",
      alt_downloadSuccessStories: "Success stories",
      yes: "Yes",
      no: "No",
    },
    disclaimer: {
      heading: `Disclaimer`,
      text1: `Due to continuous product research, technology updates and regulatory requirements, the information displayed on this website is subject to change without notifications. Although every effort has been made to ensure all information is accurate, ExxonMobil and/or its affiliates will not be held responsible for the loss or damages caused by errors, omissions, misprints or misinterpretation of the contents displayed on this application. The information displayed may not be copied, reproduced or disclosed in any manner whatsoever by the recipient without prior written consent from ExxonMobil.`,
      text2: `The technical information and recommendations are offered for buyers, its users, and customer’s considerations, investigations and verification and relate only to the named product or materials when not in combination with any other product or material. The user is solely responsible for all determinations and check regarding any use of material or product and any process. The information and recommendations are always subject to and does not prevail over, any recommendation from a motor/equipment/machinery builder. ExxonMobil Lubricants expressly disclaims any and all liability of direct, indirect or consequential nature for any loss, damage, or injury suffered or incurred, directly and indirectly, as to any results obtained or arising from any use of the product or material in reliance on this technical information and recommendations for such use.`,
    },
    productTable: {
      includesNaturalGas: "Suitable products for natural gas engines",
      syntheticOil: "Synthetic oil",
      suitableBioLandSewage: "Suitable products for biogas, landfill and sewage gas engines",
      productName: "Product name",
      sulphatedAsh: "Sulphated ash %",
      totalBaseNumber: "Total base number",
      saeGrade: "SAE grade",
      oilDrainInterval: "Oil drain interval",
      wearProtection: "Wear protection",
      oxidationResistance: "Oxidation / nitration resistance",
      engineCleanliness: "Engine cleanliness / deposit control",
    },
    searchTypeSelectorPage: {
      name: "Search type",
      progressHeading: "Choose which you'd like to search by",
    },
    searchTypeSelector: {
      engineType: "Engine type",
      specification: "Specification",
    },
    specificationGroupPage: {
      name: "Specification",
      progressHeading: "Choose specification",
    },
    engineModelGroupPage: {
      name: "Engine model",
      progressHeading: "Choose gas engine model",
    },
    gasTypePage: {
      progressHeading: "What gas type is your engine?",
      name: "Gas type",
    },
    catalystPage: {
      progressHeading: "Does your engine have a Selective Catalytic Reduction (SCR) system fitted?",
      name: "Catalyst",
    },
    resultsPage: {
      progressHeading: "Results",
      name: "Recommended products",
      heading: "We recommend the following products:",
      buyButtonText: "Where to buy",
      buyButtonLink: "https://www.global.mobil.com/en/lubricants-distributors",
      newSearchText: "New search",
      approvalType: "Approval Type",
    },
    homePage: {
      progressHeading: "Choose your gas engine brand​",
      intro: ({ anchor }) => `Find the right oil for your gas engine.  
Select your gas engine brand from the list below and we will provide the right recommendation for your gas engine.

View [product table](${anchor}) below for our full product offer and comparison list.
      `,
      productComparisonListTitle: `Full product comparison list`,
      productComparisonListBody: `<p>View table below to review and compare the Mobil Pegasus™ lubricants properties.</p><p><b>Tips:</b></p><ul><li>Click on the table headings to sort in ascending or descending order.</li><li>Clicking on the product name will open the product page where you can view the full technical product details.</li></ul>`,
    },
    footer: {
      energyLivesHere: "Energy lives here™",
      selectLocation: "Select location",
      privacyPolicy: { text: "Privacy Policy", url: "http://corporate.exxonmobil.com/en/global-legal-pages/privacy-policy" },
      termsAndConditions: { text: "Terms & Conditions", url: "http://corporate.exxonmobil.com/en/global-legal-pages/terms-and-conditions" }
    },
  },
  "tr-tr": {
    metaData: {
      title: "Gaz motoru ürün seçme aracı | Mobil™",
      desc: "Gaz motorunuz için doğru yağı bulun."
    },
    header: {
      businessLines: {
        text: `İş kolu`,
        link: "https://corporate.exxonmobil.com/About-us/Business-divisions"
      },
      globalBrands: {
        text: `Global markalar`,
        link: "https://corporate.exxonmobil.com/About-us/Brands"
      },
    },
    languages: {
      active: {
        text: 'Türkiye - Türk',
        link: "#"
      },
      english: {
        text: 'UK - English',
        link: "/en/"
      },
      german: {
        text: 'Deutschland - Deutsch',
        link: "/de/"
      },
      turkish: {
        text: 'Türkiye - Türk',
        link: "/tr/"
      },
      italian: {
        text: 'Italia - Italiano',
        link: "/it/"
      },
      french: {
        text: 'France - Francais',
        link: "/fr/"
      },
      polish: {
        text: 'Polska - Polski',
        link: "/pl/"
      }
    },
    email: {
      title: "Mobil™ ürün tavsiyeniz ektedir",
      salutation: "Merhaba",
      placeholder: "E-posta*",
      sending: "Gönderiliyor...",
      message:
        "<a href='https://geoselector.eame.mobil.com/tr/'>Mobil gaz motoru yağları web sayfasını</a> ziyaret ettiğiniz için teşekkür ederiz.Talep ettiğiniz Mobil™ ürün tavsiyenizi ekte bulabilirsiniz.​\n\nTeknik sorularınız varsa veya tavsiye edilen gaz motoru yağlarını nereden alabileceğinizi öğrenmek istiyorsanız, <a href='https://www.mobiloil.com.tr/tr-tr/contact-us'>lütfen bizimle iletişime geçin</a>.\n\nSaygılarımızla,\n\nMobil ekibi",
      pdfFileName: "Ürün-tavsiyesi.pdf",
      sendButton: "Gönder",
      successfulEmailMessage: "E-posta gönderildi. Gelen kutunuzda e-postayı bulamıyorsanız, lütfen istenmeyen e-posta klasörünüzü kontrol edin.",
      privacyPolicy: "Gizlilik politikası",
      termsAndConditions: "Hükümler ve koşullar",
    },
    breadcrumbs: {
      yourSelection: "Seçiminiz: "
    },
    cookies: {
      consentCopy:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      acceptButton: "Accept cookies",
      rejectButton: "No thanks",
    },
    common: {
      compareRecos: "Önerilen ürünleri karşılaştırın",
      moreRecos: "Daha fazla tavsiye",
      productSelector: "Gaz motorunuz için Mobil ürün seçme aracı",
      endOfpageNotes: `Gaz motoru modelinizi veya teknik özelliklerini bulamıyor musunuz? Bize ulaşın. (https://www.mobiloil.com.tr/tr-tr/contact-us). 

Aynı zamanda, ürünlerin gaz motorunuz için uygun olduğundan emin olmak için, üretici tarafından sağlanan şartnamelere göre ürün tavsiyelerini gözden geçirmenizi öneririz.

Firma, ürünleri araştırmaya ve iyileştirmeye devam ettikçe, yayınlanan ürün bilgileri herhangi bir zamanda haber verilmeden güncellenebilir. Standart performans biraz değişebilir. 

Tüm ürünler tüm pazarlar için mevcut değildir ve yalnızca belirli ülkelerde geçerli olabilir. Gaz motoru gereksinimlerinize ve konumunuza uygun çözümler için teknik destek masamız ile iletişime geçin. 
[Yasal Uyarı](#/disclaimer)`,
    },
    copyright: {
      text: "© Copyright 2021 Exxon Mobil Corporation Tüm hakları saklıdır."
    },
    button: {
      moreHelp: `**Gaz motorunuzu veya tavsiye edilen ürünü bulmak için daha fazla yardıma mı ihtiyacınız var?**  
Daha fazla destek için teknik destek masamızla iletişime geçin.`,
      moreHelpUrl: `https://www.mobiloil.com.tr/tr-tr/contact-us`,
      visitHub: `null`,
      visitHubUrl: `https://www.global.mobil.com/en/gas-engine-hub`,
      MSLA: `**Gaz motorları için Mobil ℠ hizmetlerinin avantajlarını keşfedin.**`,
      MSLAUrl: `https://www.mobiloil.com.tr/tr-tr/mobil-serv`,
      moreTechInfo: `**Daha fazla teknik veya ticari bilgiye ihtiyacınız mı var? Hemen deneyimli ekibimizle iletişime geçin.**`,
      moreTechInfoUrl: `https://www.mobiloil.com.tr/tr-tr/contact-us`,
      viewProductDetails: "Ürün bilgilerinin tamamını görüntüleyin",
      downloadPerformanceProfile: "Performans profili PDF dosyasını indirin",
      downloadSuccessStories: "Başarı hikayeleri PDF dosyasını indirin",
      alt_downloadPerformanceProfile: "Performans profili",
      alt_downloadSuccessStories: "Başarı hikayeleri",
      yes: "Evet",
      no: "Hayır",
    },
    disclaimer: {
      heading: `Yasal Uyarı`,
      text1: `Bu web sitesinde gösterilen bilgiler, ürün konusunda sürekli devam eden araştırmalar, teknolojik güncellemeler ve yasal düzenlemelerin gereksinimleri nedeniyle önceden bildirim yapılmadan değiştirilebilir. Bilgilerin tamamının doğru olduğundan emin olmak için her tür çaba gösterilmiş olmasına rağmen, ExxonMobil (Mobil Oil Türk A.Ş.) ve/veya bağlı kuruluşları, bu uygulamada gösterilen içerikle ilgili hatalar, eksikler, yazım yanlışları veya yanlışanlamalardan kaynaklanan kayıp veya zararlardan sorumlu tutulamaz. Görüntülenen bilgiler, ExxonMobil(Mobil Oil Türk A.Ş.) 'in önceden yazılı izni olmadan alıcı tarafından hiçbir şekilde kopyalanamaz, çoğaltılamaz veya ifşa edilemez.`,
      text2: `Teknik bilgiler ve tavsiyeler alıcılara, kullanıcılarına ve müşterilere değerlendirme, araştırma ve doğrulama amacıyla sunulur ve başka bir ürün veya malzeme ilebirlikte kullanılmadığında, sadece adı geçen ürün veya malzemelerle ilgilidir. Kullanıcı, herhangi bir malzeme veya ürünün kullanımı ve herhangi bir süreçle ilgili tüm saptamalardan ve kontrollerden tek başına sorumludur. Bilgiler ve tavsiyeler, her zamanbir motor/ekipman/makine üreticisinin tavsiyesine tabidir ve bu tavsiyelere aykırı olamaz. ExxonMobil Madeni Yağları (Mobil Oil Türk A.Ş.), ürün veya malzemenin, bu teknik bilgi veya tavsiyelere göre bu tür bir kullanımından ortaya çıkan veya doğan sonuçlarla alakalı, doğrudan, dolaylı veya sonuca bağlı olarak oluşan herhangi bir kayıp, zarar ve uğranılan veya maruz kalınan hasardan veya yaralanmadan doğabilecek her türlü ve tüm sorumluluğu kesinlikle reddeder.`,
    },
    productTable: {
      includesNaturalGas: "Doğal gaz motorları için uygun ürünler",
      syntheticOil: "Sentetik yağ",
      suitableBioLandSewage: "Biyogaz, çöp gazı ve kanalizasyon gazı motorları için uygun ürünler",
      productName: "Ürün adı",
      sulphatedAsh: "Sülfatlanmış kül %",
      totalBaseNumber: "Toplam baz sayısı (TBN)",
      saeGrade: "SAE sınıfı",
      oilDrainInterval: "Yağ değişim aralığı",
      wearProtection: "Aşınmaya karşı koruma",
      oxidationResistance: "Oksidasyon/nitratlaşma direnci",
      engineCleanliness: "Motor temizliği/birikinti kontrolü ",
    },
    searchTypeSelectorPage: {
      name: "Search type",
      progressHeading: "Choose which you'd like to search by",
    },
    searchTypeSelector: {
      engineType: "Arama türü",
      specification: "Şartname",
    },
    specificationGroupPage: {
      name: "Şartname",
      progressHeading: "Şartname seçin",
    },
    engineModelGroupPage: {
      name: "Motor modeli",
      progressHeading: "Gaz motoru modelini seçin",
    },
    gasTypePage: {
      progressHeading: "Motorunuz hangi gaz türü için üretilmiştir?",
      name: "Gaz türü",
    },
    catalystPage: {
      progressHeading: "Motorunuzda SCR (Selective Catalytic Reduction) / seçici katalitik indirgeme sistemi mevcut mu?​",
      name: "Katalizör",
    },
    resultsPage: {
      progressHeading: "Sonuçlar",
      name: "Tavsiye edilen ürünler",
      heading: "Aşağıdaki ürünleri öneririz",
      buyButtonText: "Nereden satın alabilirim?",
      buyButtonLink: "https://www.mobiloil.com.tr/tr-tr/where-to-buy",
      newSearchText: "Yeni arama",
      approvalType: "Onay Türü",
    },
    homePage: {
      progressHeading: "Gaz motoru markanızı seçin​",
      intro: ({ anchor }) => `Gaz motorunuz için doğru yağı bulun. 
Aşağıdaki listeden gaz motoru markanızı seçin, gaz motorunuz için doğru tavsiyeyi biz sağlayalım.

Ürün portföyümüzün tamamı ve karşılaştırma listemiz için aşağıda [ürün tablosu](${anchor}) öğesini görüntüleyin.
      `,
      productComparisonListTitle: `Tam ürün karşılaştırma listesi`,
      productComparisonListBody: `<p>Mobil Pegasus™ yağlarının özelliklerini incelemek ve karşılaştırmak için aşağıdaki tabloyu inceleyin.</p><p><b>İpuçları:</b></p><ul><li>Artan veya azalan sıraya göre sıralamak için tablo başlıklarına tıklayın.</li><li>Ürün adına tıkladığınızda, ürünün tüm teknik ayrıntılarını görüntüleyebileceğiniz ürün sayfası açılacaktır.</li></ul>`,
    },
    footer: {
      energyLivesHere: "Energy lives here™",
      selectLocation: "Konum seçin",
      privacyPolicy: { text: "Gizilik Politikasi​", url: "https://corporate.exxonmobil.com/global-legal-pages/privacy-policy_turkey-turkish" },
      termsAndConditions: { text: "Kosullar ve Sartlar", url: "https://corporate.exxonmobil.com/global-legal-pages/terms-and-conditions_turkey-turkish" }
    },
  },
  "it-it": {
    metaData: {
      title: "Selettore dei prodotti per motori a gas | Mobil™",
      desc: "Trova l’olio ideale per il tuo motore a gas."
    },
    header: {
      businessLines: {
        text: `Linea di business`,
        link: "https://corporate.exxonmobil.com/About-us/Business-divisions"
      },
      globalBrands: {
        text: `Marchi globali`,
        link: "https://corporate.exxonmobil.com/About-us/Brands"
      }
    },
    languages: {
      active: {
        text: 'Italia - Italiano',
        link: "#"
      },
      english: {
        text: 'UK - English',
        link: "/en/"
      },
      german: {
        text: 'Deutschland - Deutsch',
        link: "/de/"
      },
      turkish: {
        text: 'Türkiye - Türk',
        link: "/tr/"
      },
      italian: {
        text: 'Italia - Italiano',
        link: "/it/"
      },
      french: {
        text: 'France - Francais',
        link: "/fr/"
      },
      polish: {
        text: 'Polska - Polski',
        link: "/pl/"
      }
    },

    email: {
      title: "In allegato, alcuni consigli sui prodotti Mobil™",
      salutation: "Buongiorno",
      placeholder: "E-mail*",
      sending: "Invio...",
      message:
        "Grazie per aver visitato <a href='https://geoselector.eame.mobil.com/it/'>la pagina web dedicata agli oli Mobil per motori a gas</a>. In allegato troverai i consigli sui prodotti Mobil™ che hai richiesto.\n\nPer domande tecniche o per informazioni su dove acquistare gli oli per motori a gas consigliati, <a href='https://www.mobil.it/it-it/contact-us​'>contattaci</a>.\n\nCordiali saluti, \n\nIl team Mobil",
      pdfFileName: "Product-recommendation.pdf",
      sendButton: "Invia",
      successfulEmailMessage: "L’e-mail è stata inviata. Se non la trovi nella casella di posta in arrivo, controlla nello spam o nella posta indesiderata.",
      privacyPolicy: "Informativa sulla privacy",
      termsAndConditions: "Termini e condizioni",
    },
    breadcrumbs: {
      yourSelection: "La tua selezione:"
    },
    cookies: {
      consentCopy:
        'orem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",',
      acceptButton: "Accept cookies",
      rejectButton: "No thanks",
    },
    common: {
      compareRecos: "Confronto tra i prodotti consigliati",
      moreRecos: "Altri consigli",
      productSelector: "Selettore dei prodotti Mobil per motori a gas",
      endOfpageNotes: `Non trovi il modello o le specifiche del tuo motore a gas? Contattaci(https://www.mobil.it/it-it/contact-us). 

Ti invitiamo anche a consultare i consigli relativi ai prodotti in base alle specifiche fornite dal produttore per verificare che siano adatti al motore a gas in uso.
As the company continues to research and improve products, the product information posted may be updated at any time without notice. Standard performance may vary slightly. 

NI prodotti non sono disponibili su tutti i mercati e potrebbero riguardare solo determinati Paesi. Contatta la nostra assistenza tecnica per soluzioni personalizzate in base ai requisiti e all’ubicazione del tuo motore a gas. 


[Esclusione di responsabilità](#/disclaimer)`,
    },
    copyright: {
      text: "© Copyright 2021 Exxon Mobil Corporation. Tutti i diritti riservati. "
    },
    button: {
      moreHelp: `**Hai bisogno di ulteriore aiuto per individuare il tuo motore a gas o di altri consigli?**  
Per maggiori informazioni, contatta la nostra assistenza tecnica.`,
      moreHelpUrl: `https://www.mobil.it/it-it/contact-us`,
      visitHub: `null`,
      visitHubUrl: `https://www.global.mobil.com/en/gas-engine-hub`,
      MSLA: `**Scopri i vantaggi dei servizi Mobil℠ servizi per i motori a gas.**`,
      MSLAUrl: `https://www.mobil.it/it-it/mobil-serv`,
      moreTechInfo: `**Vorresti ulteriori informazioni tecniche o commerciali? Contatta subito il nostro team di esperti**`,
      moreTechInfoUrl: `https://www.mobil.it/it-it/contact-us`,
      viewProductDetails: "Visualizza tutti i dettagli del prodotto ",
      downloadPerformanceProfile: "Scarica il profilo delle prestazioni in PDF",
      downloadSuccessStories: "Scarica le storie di successo in PDF",
      alt_downloadPerformanceProfile: "Profilo delle prestazioni ",
      alt_downloadSuccessStories: "Storie di successo",
      yes: "Si",
      no: "No",
    },
    disclaimer: {
      heading: `Esclusione di responsabilità`,
      text1: `Come conseguenza della continua attività di ricerca sui prodotti, degli aggiornamenti tecnologici e dei requisiti normativi, le informazioni riportate in questo sito web sono soggette a modifiche senza preavviso. Pur facendo il possibile per garantire l’accuratezza di tutte le informazioni, ExxonMobil e/o le sue affiliate declinano ogni responsabilità in relazione a eventuali perdite o danni derivanti da errori, omissioni, errori di stampa o errata interpretazione dei contenuti visualizzati su questa applicazione. Le informazioni visualizzate non possono essere copiate, riprodotte né divulgate in alcun modo dal destinatario se non con il previo consenso scritto di ExxonMobil.`,
      text2: `Le informazioni tecniche e i consigli sono offerti agli acquirenti, agli utenti e ai clienti affinché vengano da questi valutati, esaminati e verificati; si riferiscono solo al prodotto o ai materiali indicati escludendo qualsiasi combinazione con altri prodotti o materiali. L’utente è il solo responsabile di qualsiasi decisione e verifica in relazione all’utilizzo del materiale o del prodotto e a qualsiasi procedura svolta. Le informazioni e i consigli sono sempre subordinati ai consigli dei costruttori di motori/attrezzature/macchinari e non prevalgono su questi ultimi. ExxonMobil Lubricants declina espressamente qualsiasi responsabilità diretta, indiretta o consequenziale in relazione a eventuali perdite, danni o lesioni subite o sostenute, direttamente o indirettamente, in merito a qualsiasi risultato ottenuto o derivante da qualsiasi utilizzo di prodotti o materiali in base alle informazioni tecniche e ai consigli per l’uso qui riportati.`,
    },
    productTable: {
      includesNaturalGas: "Prodotti idonei per motori a gas naturale",
      syntheticOil: "Olio sintetico ",
      suitableBioLandSewage: "Prodotti idonei per motori a biogas, a gas di discarica e gas da liquami ",
      productName: "Nome prodotto",
      sulphatedAsh: "Ceneri solfatate %",
      totalBaseNumber: "Indice di alcalinità",
      saeGrade: "Grado SAE",
      oilDrainInterval: "Intervallo di sostituzione dell’olio ",
      wearProtection: "Protezione contro l’usura",
      oxidationResistance: "Resistenza all’ossidazione e alla nitrazione",
      engineCleanliness: "Pulizia del motore e controllo dei depositi",
    },
    searchTypeSelectorPage: {
      name: "Tipo di ricerca ",
      progressHeading: "Scegli il criterio di ricerca ",
    },
    searchTypeSelector: {
      engineType: "Tipo di motore ",
      specification: "Specifica ",
    },
    specificationGroupPage: {
      name: "Specification",
      progressHeading: "Scegli la specifica",
    },
    engineModelGroupPage: {
      name: "Modello di motore",
      progressHeading: "Scegli il modello di motore a gas",
    },
    gasTypePage: {
      progressHeading: "Che tipo di gas utilizza il tuo motore?",
      name: "Tipo di gas",
    },
    catalystPage: {
      progressHeading: "Il vostro motore è dotato di un sistema di riduzione selettiva catalitica (SCR)?​",
      name: "Catalizzatore",
    },
    resultsPage: {
      progressHeading: "Risultati",
      name: "Prodotti consigliati",
      heading: "Consigliamo i seguenti prodotti",
      buyButtonText: "Dove acquistare",
      buyButtonLink: "https://www.mobil.it/it-it/distributor-locator",
      newSearchText: "Nuova ricerca",
      approvalType: "Tipo di approvazione",
    },
    homePage: {
      progressHeading: "Scegli il marchio del tuo motore a gas​",
      intro: ({ anchor }) => `Trova l’olio ideale per il tuo motore a gas.  
Seleziona la marca del tuo motore a gas nell’elenco: ti forniremo consigli specifici per il tuo motore. 
Osserva la [tabella dei prodotti](${anchor}) qui di seguito per l’offerta completa dei prodotti e per il confronto.
      `,
      productComparisonListTitle: `Elenco completo dei prodotti per il confronto`,
      productComparisonListBody: `<p>Osserva la tabella qui sotto per esaminare e confrontare le proprietà dei lubrificanti Mobil Pegasus™</p><p><b>Suggerimenti:</b></p><ul><li>Fai clic sui titoli della tabella per disporre le voci in ordine crescente o decrescente.</li><li>Facendo clic sul nome di ogni prodotto si aprirà la pagina corrispondente, con i dettagli tecnici completi del prodotto.</li></ul>`,
    },
    footer: {
      energyLivesHere: "Energy lives here™",
      selectLocation: "Seleziona la località",
      privacyPolicy: { text: "Privacy Statement​", url: "https://www.exxonmobil.it/it-it/Legal/Privacy-Statement" },
      termsAndConditions: { text: "Note Legali", url: "https://corporate.exxonmobil.com/Global-legal-pages/terms-and-conditions" }
    },
  },
  "de-de": {
    metaData: {
      title: "Produkt-Wegweiser für Gasmotoren | Mobil™",
      desc: "Finden Sie das richtige Motorenöl für Ihren Gasmotor."
    },
    header: {
      businessLines: {
        text: `Geschäftsbereich`,
        link: "https://corporate.exxonmobil.com/About-us/Business-divisions"
      },
      globalBrands: {
        text: `Globale Marken`,
        link: "https://corporate.exxonmobil.com/About-us/Brands"
      },
    },
    languages: {
      active: {
        text: 'Deutschland - Deutsch',
        link: "#"
      },
      english: {
        text: 'UK - English',
        link: "/en/"
      },
      german: {
        text: 'Deutschland - Deutsch',
        link: "/de/"
      },
      turkish: {
        text: 'Türkiye - Türk',
        link: "/tr/"
      },
      italian: {
        text: 'Italia - Italiano',
        link: "/it/"
      },
      french: {
        text: 'France - Francais',
        link: "/fr/"
      },
      polish: {
        text: 'Polska - Polski',
        link: "/pl/"
      }
    },
    email: {
      title: "Im Anhang: Ihre Mobil™ Schmierstoffempfehlung",
      salutation: "Hallo",
      placeholder: "E-Mail-Adresse*",
      sending: "Wird gesendet...",
      message:
        "vielen Dank, <a href='https://geoselector.eame.mobil.com/de/'>dass Sie die Mobil Website für Gasmotorenöle besuchen</a>. Im Anhang finden Sie die von Ihnen angeforderte Mobil™ Schmierstoffempfehlung.\n\nBei technischen Fragen oder wenn Sie wissen wollen, wo Sie die empfohlenen Gasmotorenöle erwerben können, <a href='https://www.global.mobil.com/en/cSontact-us​'>kontaktieren Sie uns bitte</a>.\n\nMit freundlichen Grüßen\n\nDas Mobil Team",
      pdfFileName: "Product-recommendation.pdf",
      sendButton: "Senden",
      successfulEmailMessage: "E-Mail wurde gesendet. Falls sie nicht in Ihrem Posteingang eingeht, kontrollieren Sie bitte Ihren Spam-oder Junk-Mail-Ordner.",
      privacyPolicy: "Privacy policy",
      termsAndConditions: "Terms and conditions",
    },
    breadcrumbs: {
      yourSelection: "Ihre Auswahl: "
    },
    cookies: {
      consentCopy:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      acceptButton: "Accept cookies",
      rejectButton: "No thanks",
    },
    common: {
      compareRecos: "Empfohlene Gasmotorenölevergleichen",
      moreRecos: "Weitere Empfehlungen",
      productSelector: "Mobil Produkt-Wegweiser für Ihren Gasmotorenöle",
      endOfpageNotes: `Sie können das Modell oder die Schmierstoffspezifikation Ihres Gasmotors nicht finden? [Sprechen Sie mit uns](https://www.mobil.com.de/de-de/industrial/contact-us). 

Gleichzeitig können Sie anhand der Herrstellerempfehlungen vergleichen, ob die Schmierstoffe für Ihren Gasmotor geeignet sind.

Durch die kontinuierliche Forschung und Verbesserung der Gasmotorenöle können die bereitgestellten Informationen jederzeit und ohne Vorankündigung durch uns aktualisiert werden, wobei standardmäßig erreichte Leistungsergebnisse sich geringfügig unterscheiden können.
Nicht alle Gasmotorenöle werden auf allen Märkten angeboten, sondern treffen ggf. nur auf bestimmte Länder zu. Wenden Sie sich an unseren technischen Support, um maßgeschneiderte Lösungen für Ihren Gasmotor passend zu Ihrem Standort zu erhalten. 

[Haftungsausschluss](#/disclaimer)`,
    },
    copyright: {
      text: "© Copyright 2021 Exxon Mobil Corporation. Alle Rechte vorbehalten."
    },
    button: {
      moreHelp: `**Sie benötigen weitere Hilfe rund um Ihren Gasmotor oder eine Empfehlung?**  
Kontaktieren Sie unseren Technischen Support, um weitere Unterstützung zu erhalten.`,
      moreHelpUrl: `https://www.mobil.com.de/de-de/industrial/contact-us`,
      visitHub: `**Im Mobil Treffpunkt für Gasmotorenöle finden Sie neueste Branchenerkenntnisse, Trends sowie Schmierstoff-und Serviceinformationen.**`,
      visitHubUrl: `https://www.mobil.com.de/de-de/industrial/lubricants/applications/gas-engines`,
      MSLA: `**Erfahren Sie mehr über die Vorteile der Mobil℠ services für Gasmotoren.**`,
      MSLAUrl: `https://www.mobil.com.de/de-de/industrial/lubricant-expertise/categories/mobil-serv`,
      moreTechInfo: `**Unser erfahrenes Team steht Ihnen bei technischen Fragen und Informationen zu Produktivitätssteigerungen gerne zur Verfügung. Kontaktieren Sie uns noch heute.**`,
      moreTechInfoUrl: `https://www.mobil.com.de/de-de/industrial/contact-us`,
      viewProductDetails: "Vollständige Schmierstoffdetailsaufrufen",
      downloadPerformanceProfile: "Performance Profil alsPDF herunterladen",
      downloadSuccessStories: "Erfolgsgeschichten als PDF herunterladen",
      alt_downloadPerformanceProfile: "Performance Profil",
      alt_downloadSuccessStories: "Erfolgsgeschichten",
      yes: "Ja",
      no: "Nein",
    },
    disclaimer: {
      heading: `Haftungsausschluss`,
      text1: `Aufgrund kontinuierlicher Schmierstoffforschung,Technologieaktualisierungen und gesetzlichen Anforderungen sind Änderungen an den auf dieser Website angezeigten Informationen vorbehalten. Obwohl die Genauigkeit aller Informationen sorgfältig überprüft wurde, können ExxonMobil und/oder verbundene Unternehmen nicht für Verluste oder Schäden haftbar gemacht werden, die durch Fehler, Auslassungen, Fehldrucke oder Missdeutung der in dieser Anwendung angezeigten Inhalte verursacht werden. Die angezeigten Informationen dürfen vom Empfänger in keiner Weise kopiert, reproduziert oder veröffentlicht werden, wenn dafür keine schriftliche Genehmigung von ExxonMobil vorliegt.`,
      text2: `Die technischen Informationen und Empfehlungen werdenfür Käufer, deren Anwender und als Entscheidungshilfe für Kunden, für Untersuchungen und Überprüfungen angeboten. Sie beziehen sich ausschließlich auf das angegebene Produkt oder Material, wenn sie nicht mit einem anderen Produkt oder Material kombiniert werden. Allein der Anwender ist für alle Bestimmungen und Prüfungen hinsichtlich des Einsatzes eines Materials oder Produkts und jeglicher Prozesse verantwortlich. Die Informationen und Empfehlungen unterliegen den Empfehlungen des Motor-/Anlagen/Maschinenherstellers und gehen diesen nicht vor.ExxonMobil Lubricants schließt ausdrücklich jegliche und alle Haftung direkter, indirekter oder abhängiger Natur für jegliche Verluste, Schäden oder Verletzungen aus, die sich direkt oder indirekt aus dem Einsatz desin diesen technischen Informationen angegebenen Produkts oder Materials und aus den Empfehlungen für solch einen Einsatz ergeben.`,
    },
    productTable: {
      includesNaturalGas: "Geeignete Produkte für mit Erdgas betriebene Motoren",
      syntheticOil: "Hochleistungsöl",
      suitableBioLandSewage: "Geeignete Produkte für mit Bio-, Deponie-und Klärgas betriebene Motoren",
      productName: `Produkt-name`,
      sulphatedAsh: "Sulfat-asche %",
      totalBaseNumber: "Gesamt-basenzahl (TBN) ",
      saeGrade: "SAE-Klasse",
      oilDrainInterval: "Ölwechsel-intervall",
      wearProtection: "Verschleiß-schutz",
      oxidationResistance: "Oxidations-/ Nitrationsbeständigkeit",
      engineCleanliness: "Motorensauberkeit/ Ablagerungskontrolle",
    },
    searchTypeSelectorPage: {
      name: "yp suchen",
      progressHeading: "Suchkriterium auswählen",
    },
    searchTypeSelector: {
      engineType: "Motortyp",
      specification: "Spezifikation",
    },
    specificationGroupPage: {
      name: "Specification",
      progressHeading: "Spezifikation auswählen",
    },
    engineModelGroupPage: {
      name: "Motormodell",
      progressHeading: "Gasmotorenmodell auswählen",
    },
    gasTypePage: {
      progressHeading: "Welcher Gastyp kommt in Ihrem Motor zum Einsatz?",
      name: "Gastyp",
    },
    catalystPage: {
      progressHeading: "Ist Ihr Motor mit einem selektiven katalytischen reduktionssystem ausgestattet?​",
      name: "Katalysator",
    },
    resultsPage: {
      progressHeading: "Ergebnisse:",
      name: "Empfohlene Produkte",
      heading: "Wir empfehlen die folgenden Produkte",
      buyButtonText: "Bezug der Produkte",
      buyButtonLink: "https://www.mobil.com.de/de-de/industrial/lubricants-distributors",
      newSearchText: "Neue Suche",
      approvalType: "Typ der Freigabe",
    },
    homePage: {
      progressHeading: "Wählen Sie die Marke Ihres Gasmotors aus ",
      intro: ({ anchor }) => `Finden Sie das richtige Motorenöl für Ihren Gasmotor. 
Wählen Sie die Marke Ihres Gasmotors aus der nachfolgenden Liste aus und Sie erhalten von uns die richtige Produktempfehlung dafür.

In der [Produkttabelle](${anchor}) unten finden Sie unser vollständiges Motorenölangebot und eine Vergleichsliste.
      `,
      productComparisonListTitle: `Liste mit vollständigem Motorenölvergleich`,
      productComparisonListBody: `<p>In der nachfolgenden Tabelle können Sie die Eigenschaften der Mobil Pegasus™ Gasmotorenöle ansehen und vergleichen.</p><p><b>Tipps:</b></p><ul><li>Klicken Sie auf die Tabellenüberschriften, um die Tabelle in auf- oder absteigender Reihenfolge zu sortieren.</li><li>Wenn Sie auf einen Produktnamen klicken, wird die entsprechende Seite geöffnet. Dort finden Sie die vollständigen technischen Details des Gasmotorenöls.</li></ul>`,
    },
    footer: {
      energyLivesHere: "Energy lives here™",
      selectLocation: "Standort wählen",
      privacyPolicy: { text: "Datenschutzerklärung", url: "https://corporate.exxonmobil.de/de-de/legal-pages/Datenschutzerklarung" },
      termsAndConditions: { text: "Nutzungsbedingungen", url: "https://corporate.exxonmobil.de/de-de/legal-pages/Nutzungsbedingungen" }
    },
  },
  "fr-fr": {
    metaData: {
      title: "Outil de sélection de produits pour moteurs à gaz | Mobil™",
      desc: "Choisissez l’huile adaptée à votre moteur à gaz."
    },
    header: {
      businessLines: {
        text: `Secteur d’activité`,
        link: "https://corporate.exxonmobil.com/?query=https%3a%2f%2fdnet.mobil.com%2fen%2f#business-lines"
      },
      globalBrands: {
        text: `Marques mondiales`,
        link: "https://corporate.exxonmobil.com/?query=https%3a%2f%2fdnet.mobil.com%2fen%2f#global-brands"
      }
    },
    languages: {
      active: {
        text: 'France - Francais',
        link: "#"
      },
      english: {
        text: 'UK - English',
        link: "/en/"
      },
      german: {
        text: 'Deutschland - Deutsch',
        link: "/de/"
      },
      turkish: {
        text: 'Türkiye - Türk',
        link: "/tr/"
      },
      italian: {
        text: 'Italia - Italiano',
        link: "/it/"
      },
      french: {
        text: 'France - Francais',
        link: "/fr/"
      },
      polish: {
        text: 'Polska - Polski',
        link: "/pl/"
      }
    },
    email: {
      title: "Vous trouverez ci-joint votre recommandation de produit Mobil™.",
      salutation: "Bonjour",
      placeholder: "Email*",
      sending: "Envoi en cours...",
      message:
        "Merci d’avoir consulté <a href='https://geoselector.eame.mobil.com/fr/'>la page Web des huiles pour moteurs à gaz Mobil </a>. Veuillez trouver ci-joint votre recommandation de produit Mobil™ que vous avez demandée.​\n\nSi vous avez des questions techniques ou souhaitez savoir où acheter les huiles pour moteurs à gaz recommandées, <a href='https://www.mobil.fr/fr-fr/contact-us'>veuillez nous contacter.</a>.\n\nCordialement,\n\nL’équipe Mobil",
      pdfFileName: "Product-recommendation.pdf",
      sendButton: "Envoyer",
      successfulEmailMessage: "Votre e-mail a été envoyé. Si vous ne trouvez pas l’e-mail dans votre boîte de réception, merci de vérifier vos courriers indésirables.",
      privacyPolicy: "Déclaration sur la protection des données personnelles",
      termsAndConditions: "Conditions générales",
    },
    breadcrumbs: {
      yourSelection: "Votre sélection: "
    },
    cookies: {
      consentCopy:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      acceptButton: "Accept cookies",
      rejectButton: "No thanks",
    },
    common: {
      compareRecos: "Comparer les produits recommandés",
      moreRecos: "Autres recommandations",
      productSelector: "Outil de sélection de produits Mobil pour votre moteur à gaz",
      endOfpageNotes: `Impossible de trouver votre modèle de moteur à gaz ou votre spécification ?  [Contactez-Nous](https://www.mobil.fr/fr-fr/contact-us).

En même temps, nous vous conseillons de consulter les recommandations de produits conformément aux spécifications fournies par le fabricant pour vous assurer que les produits sont adaptés à votre moteur à gaz.

L’entreprise innove et améliore constamment ses produits, les informations publiées sur les produits peuvent donc être mises à jour à tout moment sans préavis. Les performances standard peuvent varier légèrement.

Les produits ne sont pas tous disponibles sur tous les marchés et peuvent ne s’appliquer qu’à certains pays. [Contactez notre centre d’assistance technique](https://www.mobil.fr/fr-fr/contact-us) pour obtenir des solutions adaptées à vos besoins en matière de moteur à gaz et à votre localisation.

[Mentions légales](#/disclaimer)`,
    },
    copyright: {
      text: "© Copyright 2022 Exxon Mobil Corporation. Tous droits réservés."
    },
    button: {
      moreHelp: `**Besoin d’aide pour trouver votre moteur à gaz ou obtenir une recommandation ?**  
Contactez notre service d’assistance technique pour plus d’aide.`,
      moreHelpUrl: `https://www.mobil.fr/fr-fr/contact-us`,
      visitHub: `null`,
      visitHubUrl: `https://www.global.mobil.com/en/gas-engine-hub`,
      MSLA: `**Découvrez les avantages des services Mobil℠ pour les moteurs à gaz.**`,
      MSLAUrl: `https://www.mobil.fr/fr-fr/mobil-serv`,
      moreTechInfo: `**Besoin d’informations plus techniques ou commerciales ? Contactez notre équipe expérimentée dès aujourd’hui.**`,
      moreTechInfoUrl: `https://www.mobil.fr/fr-fr/contact-us`,
      viewProductDetails: "Afficher les détails complets des produits",
      downloadPerformanceProfile: "Télécharger le fichier PDF sur le profil de performance",
      downloadSuccessStories: "Télécharger le fichier PDF sur les témoignages client",
      alt_downloadPerformanceProfile: "Profil de performance",
      alt_downloadSuccessStories: "Témoignages client",
      yes: "Oui",
      no: "Non",
    },
    disclaimer: {
      heading: `Mentions légales`,
      text1: `En raison de la recherche continue sur les produits, des mises à jour technologiques et des contraintes réglementaires, les informations visibles dans ce site Web peuvent être modifiées sans préavis. Même si tous les efforts nécessaires ont été déployés pour s’assurer de l’exactitude de toutes ces informations, ExxonMobil et/ou ses sociétés affiliées ne peuvent pas être tenues responsables des pertes ou des dommages causés par les erreurs, les omissions, les fautes typographiques ou une mauvaise interprétation du contenu dans cette application. Les informations affichées ne peuvent pas être copiées, reproduites ou divulguées de quelque manière que ce soit par le destinataire sans le consentement écrit préalable d’ExxonMobil.`,
      text2: `Les informations techniques et les recommandations sont destinées aux acheteurs, aux utilisateurs et aux clients pour leurs études, enquêtes et vérifications. Elles ne concernent que les produits ou équipements cités, lorsque ceux-ci ne sont pas associés à d’autres produits ou équipements. L’utilisateur est seul responsable des choix et contrôles relatifs à l’utilisation d’un quelconque équipement ou produit, ainsi que de tout processus. Les informations et les recommandations fournies sont toujours sujettes aux recommandations du fabricant de moteurs, d’équipements et de machines et ne prévalent sur aucune d’entre elles. ExxonMobil Lubricants décline expressément toute responsabilité de nature directe, indirecte ou conséquente pour toute perte, tout dommage ou préjudice encouru(e) ou infligé(e), directement ou indirectement, ainsi que pour tous les résultats obtenus ou dérivant d’une quelconque utilisation des produits ou équipements liés aux informations techniques et recommandations pour un tel usage. `,
    },
    productTable: {
      includesNaturalGas: "Produits adaptés aux moteurs au gaz naturel",
      syntheticOil: "Huile synthétique",
      suitableBioLandSewage: "Produits adaptés aux moteurs fonctionnant au biogaz, gaz de décharge et gaz d’égouts",
      productName: "Nom du produit",
      sulphatedAsh: "% de cendres sulfatées",
      totalBaseNumber: "Indice de basicité",
      saeGrade: "Grade SAE",
      oilDrainInterval: "Intervalle de vidange",
      wearProtection: "Protection contre l’usure",
      oxidationResistance: "Résistance à l’oxydation/la nitration",
      engineCleanliness: "Propreté du moteur/contrôle des dépôts",
    },
    searchTypeSelectorPage: {
      name: "Type de recherche",
      progressHeading: "Choisissez le type que vous souhaitez rechercher",
    },
    searchTypeSelector: {
      engineType: "Type de moteur",
      specification: "Spécifications",
    },
    specificationGroupPage: {
      name: "Spécification",
      progressHeading: "Choisir la spécification",
    },
    engineModelGroupPage: {
      name: "Modèle de moteur",
      progressHeading: "Choisir le modèle du moteur à gaz",
    },
    gasTypePage: {
      progressHeading: "Quel type de gaz alimente votre moteur ?",
      name: "Type de gaz",
    },
    catalystPage: {
      progressHeading: "Votre moteur est-il équipé d’un convertisseur catalytique Jenbacher ?",
      name: "Catalyseur",
    },
    resultsPage: {
      progressHeading: "Résultats",
      name: "Produits recommandés",
      heading: "Nous recommandons les produits suivants:",
      buyButtonText: "Où acheter",
      buyButtonLink: "https://www.global.mobil.com/en/lubricants-distributors/externallocator/?culture=fr-fr",
      newSearchText: "Nouvelle recherche",
      approvalType: "Type d’approbation",
    },
    homePage: {
      progressHeading: "Choisir votre marque de moteur à gaz",
      intro: ({ anchor }) => `Choisissez l’huile adaptée à votre moteur à gaz. 
Sélectionnez votre marque de moteur à gaz dans la liste ci-dessous et nous vous fournirons la bonne recommandation pour votre moteur à gaz.

Consultez le [tableau des produits](${anchor}) ci-dessous pour découvrir notre offre complète de produits et notre liste de comparaison.`,
      productComparisonListTitle: `Liste complète de comparaison de produits`,
      productComparisonListBody: `<p>Consultez le tableau ci-dessous pour examiner et comparer les propriétés des lubrifiants Mobil™ Pegasus.</p><p><b>Conseils :</b></p><ul><li>Cliquez sur les en-têtes du tableau pour trier par ordre croissant ou décroissant.</li><li>En cliquant sur le nom du produit, vous ouvrez la page du produit où vous pouvez afficher ses détails techniques complets.</li></ul>`,
    },
    footer: {
      energyLivesHere: "Energy lives here™",
      selectLocation: "Sélectionner un lieu",
      privacyPolicy: { text: "Déclaration sur la protection des données personnelles", url: "https://corporate.esso.fr/fr-fr/legal-pages/declaration-relative-a-la-protection-des-donnees-personnelles" },
      termsAndConditions: { text: "Conditions générales", url: "https://corporate.esso.fr/fr-fr/legal-pages/Notice-legale" }
    },
  },
  "pl-pl": {
    metaData: {
      title: "Narzędzie doboru produktów do silników gazowych | Mobil™",
      desc: "Znajdź odpowiedni olej do silnika gazowego."
    },
    header: {
      businessLines: {
        text: `Linia biznesowa`,
        link: "https://corporate.exxonmobil.com/?query=https%3a%2f%2fdnet.mobil.com%2fen%2f#business-lines"
      },
      globalBrands: {
        text: `Marki globalne`,
        link: "https://corporate.exxonmobil.com/?query=https%3a%2f%2fdnet.mobil.com%2fen%2f#global-brands"
      }
    },
    languages: {
      active: {
        text: 'Polska - Polski',
        link: "#"
      },
      english: {
        text: 'UK - English',
        link: "/en/"
      },
      german: {
        text: 'Deutschland - Deutsch',
        link: "/de/"
      },
      turkish: {
        text: 'Türkiye - Türk',
        link: "/tr/"
      },
      italian: {
        text: 'Italia - Italiano',
        link: "/it/"
      },
      french: {
        text: 'France - Francais',
        link: "/fr/"
      },
      polish: {
        text: 'Polska - Polski',
        link: "/pl/"
      }
    },
    email: {
      title: "W załączniku Twoja rekomendacja dotycząca produktów Mobil™",
      salutation: "Dzień dobry,",
      placeholder: "Email*",
      sending: "Wysyłanie...",
      message:
        "Dziękujemy za odwiedzenie <a href='https://geoselector.eame.mobil.com/pl/'>strony internetowej olejów do silników gazowych.</a>. W załączniku znajdziesz rekomendację dotyczącą produktów Mobil™. ​\n\nW przypadku pytań dotyczących kwestii technicznych lub punktów sprzedaży rekomendowanych olejów do silników gazowych, <a href='https://www.mobil.pl/pl-pl/contact-us'>prosimy o kontakt.</a>.\n\nZ poważaniem,\n\nZespół Mobil",
      pdfFileName: "Rekomendacja-produktowa.pdf",
      sendButton: "Wyślij",
      successfulEmailMessage: "Wiadomość e-mail została wysłana. Jeśli nie możesz znaleźć jej w swojej skrzynce odbiorczej, sprawdź folder spam.",
      privacyPolicy: "Polityka ochrony prywatności",
      termsAndConditions: "Regulamin",
    },
    breadcrumbs: {
      yourSelection: "Twój wybór: "
    },
    cookies: {
      consentCopy:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      acceptButton: "Accept cookies",
      rejectButton: "No thanks",
    },
    common: {
      compareRecos: "Porównaj zalecane produkty",
      moreRecos: "Więcej zaleceń",
      productSelector: "Narzędzie doboru produktów Mobil do Twojego silnika gazowego",
      endOfpageNotes: `Nie możesz znaleźć modelu lub specyfikacji swojego silnika gazowego? [Skontaktuj się z nami.](https://www.mobil.pl/pl-pl/contact-us). 

Jednocześnie zalecamy zweryfikowanie rekomendacji produktowych zawartych w specyfikacji producenta w celu zagwarantowania, że produkty są odpowiednie do posiadanego silnika gazowego.

W miarę prowadzenia kolejnych badań oraz doskonalenia produktów, opublikowane informacje dotyczące produktów mogą zostać zaktualizowane w dowolnej chwili bez powiadomienia. Standardowa wydajność może się nieznacznie różnić. 

Niektóre produkty są dostępne tylko dla wybranych rynków i mają zastosowanie tylko dla niektórych krajów.  [Skontaktuj się z naszym działem wsparcia technicznego,](https://www.mobil.pl/pl-pl/contact-us) aby uzyskać indywidualne rozwiązania dostosowane do wymogówposiadanego silnika gazowego oraz lokalizacji. 

[Zastrzeżenia prawne](#/disclaimer)`,
    },
    copyright: {
      text: "© Copyright 2022 Exxon Mobil Corporation. Wszelkie prawa zastrzeżone."
    },
    button: {
      moreHelp: `**Potrzebujesz pomocy w zlokalizowaniu silnika gazowego lub rekomendacji?**  
Skontaktuj się z naszym działem wsparcia technicznego, aby uzyskać dodatkowąpomoc.`,
      moreHelpUrl: `https://www.mobil.pl/pl-pl/contact-us`,
      visitHub: `null`,
      visitHubUrl: `https://www.global.mobil.com/en/gas-engine-hub`,
      MSLA: `**Odkryj zalety usług Mobil℠ dla silników gazowych.**`,
      MSLAUrl: `https://www.mobil.pl/pl-pl/mobil-serv`,
      moreTechInfo: `**Jeżeli potrzebujesz więcej informacji technicznych lub handlowych, już dziś skontaktuj się z naszym doświadczonym zespołem.**`,
      moreTechInfoUrl: `https://www.mobil.pl/pl-pl/contact-us`,
      viewProductDetails: "Zobacz wszystkie szczegóły na temat produktów",
      downloadPerformanceProfile: "Pobierz profil jakości w formacie PDF",
      downloadSuccessStories: "Pobierz historie sukcesu w formacie PDF",
      alt_downloadPerformanceProfile: "Profil wydajności",
      alt_downloadSuccessStories: "Historie sukcesu",
      yes: "Tak",
      no: "Nie",
    },
    disclaimer: {
      heading: `Zastrzeżenia prawne`,
      text1: `Ze względu na prowadzone nieustannie prace badawcze, rozwój technologii i zmiany wymogów prawnych, informacje udostępnione na tej stronie internetowej mogą ulec zmianie bez powiadomienia. Mimo, że dokładamy wszelkich starań, aby zagwarantować dokładność wszystkich informacji, firma ExxonMobil i/lub jej spółki zależne nie ponoszą odpowiedzialności za straty i szkody będące skutkiem błędów, pominięć, błędów drukarskich lub nieprawidłowej interpretacji treści zawartych w aplikacji. Udostępnionych informacji nie można kopiować, odtwarzać ani ujawniać w jakikolwiek sposób bez wcześniejszej pisemnej zgody ExxonMobil.`,
      text2: `Dane techniczne i rekomendacje są przeznaczone do użytku, kontroli i weryfikacji przez nabywców, użytkowników oraz klientów i dotyczą wyłącznie wymienionych produktów oraz materiałów bez łączenia ich z jakimikolwiek innymi produktami i materiałami. Za wszystkie ustalenia i kontrole związane z korzystaniem z materiałów i produktów w jakikolwiek sposób lub z jakimkolwiek procesem odpowiada wyłącznie użytkownik. Podane informacje i rekomendacje w każdym przypadku mają zastosowanie pod warunkiem zgodności z zaleceniami producenta silnika/urządzenia/pojazdu i mają od nich niższy priorytet. ExxonMobil Lubricants jednoznacznie zrzeka się wszelkiej odpowiedzialności bezpośredniej, pośredniej i wynikowej za jakiekolwiek straty, szkody oraz obrażenia wynikające, bezpośrednio lub pośrednio, z jakichkolwiek skutków użytkowania produktu lub materiału w jakikolwiek sposób w oparciu o niniejsze informacje techniczne i zalecenia dotyczące użytkowania lub związane z nimi.`,
    },
    productTable: {
      includesNaturalGas: "Produkty do silników zasilanych gazem ziemnym",
      syntheticOil: "Olej syntetyczny",
      suitableBioLandSewage: "Produkty do silników zasilanych biogazem, gazem wysypiskowym lub gazem z oczyszczalni ścieków.",
      productName: "Nazwa produktu",
      sulphatedAsh: "Popiół siarczanowy w %",
      totalBaseNumber: "Całkowita liczba zasadowa",
      saeGrade: "Klasa SAE",
      oilDrainInterval: "Okres pomiędzy wymianami oleju",
      wearProtection: "Ochrona przeciwzużyciowa",
      oxidationResistance: "Odporność na utlenianie i nitrację",
      engineCleanliness: "Czystość silnika i kontrola powstawania osadów",
    },
    searchTypeSelectorPage: {
      name: "Wyszukaj typ",
      progressHeading: "Wybierz kryterium wyszukiwania",
    },
    searchTypeSelector: {
      engineType: "Typ silnika",
      specification: "Specyfikacja",
    },
    specificationGroupPage: {
      name: "Specyfikacja",
      progressHeading: "Wybierz specyfikację",
    },
    engineModelGroupPage: {
      name: "Model silnika",
      progressHeading: "Wybierz model silnika gazowego",
    },
    gasTypePage: {
      progressHeading: "Jakim gazem zasilany jest silnik?",
      name: "Typ gazu",
    },
    catalystPage: {
      progressHeading: "Czy silnik Jenbacher jest wyposażony w katalizator?",
      name: "Katalizator",
    },
    resultsPage: {
      progressHeading: "Wyniki",
      name: "Zalecane produkty",
      heading: "Zalecamy następujące produkty:",
      buyButtonText: "Gdzie kupić?",
      buyButtonLink: "https://www.global.mobil.com/en/lubricants-distributors/externallocator/?culture=pl-pl",
      newSearchText: "Nowe wyszukiwanie",
      approvalType: "Typ aprobaty",
    },
    homePage: {
      progressHeading: "Wybierz markę silnika gazowego",
      intro: ({ anchor }) => `Znajdź odpowiedni olej dla silnika gazowego. Wybierz markę silnika z poniższej listy, a my wskażemy rekomendowany produkt.

 [Tabela poniżej](${anchor}) zawiera pełną ofertę naszych produktów oraz listę porównawczą.`,
      productComparisonListTitle: `Pełna oferta produktowa`,
      productComparisonListBody: `<p>Zobacz poniższą tabelę i porównaj właściwości środków smarnych Mobil™ Pegasus.</p><p><b>Wskazówki:</b></p><ul><li>Kliknij nagłówki tabeli, aby posortować je w kolejności rosnącej lub malejącej.</li><li>Kliknięcie nazwy produktu spowoduje otwarcie strony produktu, na której można wyświetlić pełne dane techniczne.</li></ul>`,
    },
    footer: {
      energyLivesHere: "Energy lives here™",
      selectLocation: "Wybierz lokalizację",
      privacyPolicy: { text: "Polityka ochrony prywatności", url: "https://corporate.exxonmobil.com/Global-legal-pages/privacy-policy_poland-polish" },
      termsAndConditions: { text: "Regulamin", url: "http://corporate.exxonmobil.com/en/global-legal-pages/terms-and-conditions" }
    },
  },
};

